import { render } from "./FuelData.vue?vue&type=template&id=03a7861f&scoped=true"
import script from "./FuelData.vue?vue&type=script&lang=js"
export * from "./FuelData.vue?vue&type=script&lang=js"

import "./FuelData.vue?vue&type=style&index=0&id=03a7861f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a7861f"]])

export default __exports__